const lang = {
  Basic: {
    Title: '欢迎登录药约約',
    RegisterTitle: '新用户注册',
    Phone: '手机号：',
    Name: '用户名：',
    Contacts: '联系人',
    Address: '详细地址',
    Verification: '验证码：',
    BtnLogin: '登录',
    BtnRegister: '注册',
    BtnComfirm: '确定',
    BtnCancel: '取消',
    ServicePhone: '          ',
    ServicePhoneCall: '立即拨打',
    Price: '￥',
    Hour: '时',
    Minute: '分',
    Second: '秒',
    Day: '天',
  },
  Login: {
    NameTip: '请输入用户名称',
    ContactsTip: '请输入联系人姓名',
    PhoneTip: '请输入手机号',
    AddressTip: '请输入详细地址',
    ErrorPhoneTip: '请输入正确的手机号码！',
    ErrorNameTip: '请输入用户名称',
    VerificationTip: '请输入验证码',
    VerificationGet: '发送验证码',
    VerificationReGet: '重新获取',
    SelectCustomer: '选择客户：',
    SelectCustomerTip: '点击选择客户信息',
    ErrorCustomerTip: '客户信息获取失败！'
  },

  BuyCar: {
    Title: '购物车'
  },
  ConfirmOrder: {
    Title: '确认订单'
  },
  Bread: {
    Title: '品牌专区'
  },
  List: {
    BrandFinished: '没有品牌了，看看其他的吧',
    Finished: '没有商品了，看看其他的吧',
    Error: '加载出错了~请重试！',
    Loading: '加载中~',
  },
  MsgCenter: {
    Title: '消息中心',
    ClearMsg: '确定要清空全部消息吗？',
    Clear: '清空'
  },
  Home: {
    Title: '欢迎来到药约約',
    Message: '消息',
    Switch: '切换',
    Scan: '扫一扫',
    SearchPlaceholder: '商品名称/功效'
  },
  Goods: {
    Alter: '到货通知',
    Like: '收藏',
    LeftTilte: '商品',
    CenterTitle: '基本信息',
    RightTitle: '详情',
    BaseTitle: '商品基本信息',
    Specifications: '规格',
    Sotck: '库存充裕',
    SotckLess: '库存不充裕',
    VideoTitle: '商品视频',
    DetailsTitle: '商品详情',
    Operation_Home: '首页',
    Operation_Like: '收藏',
    Operation_BuyCar: '购物车',
    Operation_AddCart: '加入购物车',
    Disabled_OverStep: '超出经营范围',
    Disabled_Undercarriage: '补货中',
    RetailPrice: '最低零售价',
    Profit: '毛利率',
    Price: '原价',
    Earn: '赚',
    ActivityTitle: "优惠",
    Activity_LQ: '领券',
    Activity_MJ: '满减',
    Activity_MZ: '买赠',
    Activity_ManZ: '满赠',
    Activity_MEFQ: '返券',
  }
};

const install = function (Vue) {
  Vue.prototype.lang = Vue.prototype.$lang = lang;
  Vue.lang = Vue.$lang = lang;
};
export default { install };
